import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import PhotoSwipe, { PhotoSwipeOptions } from 'photoswipe';
import { from, Observable } from 'rxjs';

export interface SdPhotoswipeImage {
  src: string;
  w: number;
  h: number;
  alt?: string;
  element?: HTMLElement;
}

@Injectable({
  providedIn: 'root',
})
export class SdPhotoswipeService {
  private isStylesInjected = false;

  constructor(private windowRef: WindowRef) {}

  openGallery(image: SdPhotoswipeImage | SdPhotoswipeImage[], index: number = 0): Observable<boolean> {
    return new Observable((subscriber) => {
      this.loadScript().subscribe((PhotoSwiper) => {
        this.injectStyles();

        const options: PhotoSwipeOptions = {
          dataSource: Array.isArray(image) ? image : [image],
          index: index,
          bgOpacity: 0.85,
          showHideOpacity: true,
        };

        const gallery = new PhotoSwiper(options);

        gallery.on('close', () => {
          subscriber.complete();
        });

        gallery.options.index = index;
        gallery.init();
      });
    });
  }

  private injectStyles(): void {
    if (this.isStylesInjected) {
      return;
    }

    this.isStylesInjected = true;

    const link = this.windowRef.document.createElement('link');

    link.rel = 'stylesheet';
    link.href = 'photoswipe.css';

    this.windowRef.document.head.appendChild(link);
  }

  private loadScript(): Observable<typeof PhotoSwipe> {
    return from(import('photoswipe').then((m) => m.default));
  }
}
